<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'首页推荐管理管理'},{name:'平台热点管理列表',goback:true},{name:'编辑平台热点'}]" :title="'编辑平台热点'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        label-width="100px"
                        class="demo-ruleForm"
                        label-suffix="："
                      >
                        <el-form-item
                          label="资讯名称"
                          prop="title"
                          class="formitem"
                        >
                          {{ruleForm.title}}
                        </el-form-item>
                        <el-form-item
                          label="序号"
                          prop="sort"
                        >
                          <el-input
                            v-model="ruleForm.sort"
                            placeholder="请输入"
                            maxlength="10"
                          ></el-input>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" size="small"@click="submitForm('ruleForm')">确认</el-button>
                          <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
                        </el-form-item>
                      </el-form>
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoad'
export default {
    components:{
        breadcrumb,
        upLoad
    },
    data(){
        return{
            statusList: [],//服务类型
            type: void 0,
			id:'',
            ruleForm: {
                advisoryId: null,
                sort: null,
            },
            rules: {
                sort: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (this.$reg.numPint.test(value) == false) {
                                callback(new Error('请输入正整数'))
                            } else {
                                return callback()
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                advisoryId: { required: true, message: '请选择咨询名称', trigger: 'change' }
            },
            newsDataSelect:[]
			
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		
    const {id,type} = this.$route.params
     this.id=id ||  void 0;
     this.type=type ||  void 0;
		if(id){
			  this.ruleForm.sourceId=id;
			  this.getDetail();
		}
    this.getSelect()
		
	},
   
    methods:{
      async getSelect() {
            const that = this
            const {code,data,msg} = await that.$axiosc.get(this.type==='1'?'/backstage/hotpoint/news/select':'/backstage/hotpoint/guide/select', {})
            if (code == 200) {
                    that.newsDataSelect = data || [];
                } else {
                    that.$alert(msg)
                }

        },
		getDetail(){
			this.$axiosc.get(this.type === '1'?`/backstage/hotpoint/news/details/${this.id}`:`/backstage/hotpoint/guide/details/${this.id}`).then((r)=>{
			    if(r.code==200){
            this.ruleForm.id = r.data.id || void 0
            this.ruleForm.title = r.data.title ||  void 0
            this.ruleForm.sort = r.data.sort || void 0
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //提交
         submitForm(formName) {
            console.log(this.ruleForm)
            const that = this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    that.$axioscBody.put(that.type === '1' ? 'backstage/hotpoint/news/edit' : 'backstage/hotpoint/guide/edit', that.ruleForm).then(async (r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                                that.resetForm(formName)
                            } else {
                                that.$alert(r.msg)
                            }
                        })

                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
          this.ruleForm={
                advisoryId: null,
                sort: null,
            }
            this.$router.back(-1);
          // this.$refs[formName].resetField();
        },
    }
}
</script>

<style lang="scss" scoped>
.warp{
     height:96%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding-top: 50px;
        .forms{
            max-width: 650px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: center;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>